import { MutationTree } from "vuex"
import { RootState, IUserLoginMerchants } from "./types/state"
import { IOrderDto, IPreOrderCount } from "@/types/interface/IOrderDto"
import { TrackableMessageDto } from "@/types/interface/IM/IMTypes"
import { IWindowOptions } from "../types/base/IWindowOptions"
import { NavigationMenu } from "../types/enum/OrderEnum"
import { IOrderCountDto } from "../types/interface/IOrderDto"
import {
  IStateUserInfo,
  ILoginMerchant,
} from "../types/interface/User/UserTypes"

const mutations: MutationTree<RootState> = {
  handleOrderStatusCount(state: RootState, orderStatusCount: IOrderCountDto) {
    state.orderStatusCount = orderStatusCount
  },

  handleTokenExpireTime(state: RootState, exp: number) {
    state.tokenExpireTime = exp
  },
  handleIsPc(state: RootState, isPc: boolean) {
    state.isPc = isPc
  },
  handleOpenInBrowser(state: RootState, openInBrowser) {
    state.openInBrowser = openInBrowser
  },
  handleMerchIds(state: RootState, merchIds: Array<string>) {
    state.merchIds = merchIds
  },
  handleTabIndex(state: RootState, tabIndex: NavigationMenu) {
    state.tabIndex = tabIndex
  },

  handleShowNewOrderModal(state: RootState, showNewOrderModal: boolean) {
    state.showNewOrderModal = showNewOrderModal
  },

  handleShowCombinedTab(state: RootState, showCombinedTab: boolean) {
    state.showCombinedTab = showCombinedTab
  },

  handleOrderTotal(state: RootState, total: number) {
    state.orderTotal = total
  },

  handleLoginMerchant(state: RootState, loginMerchant: ILoginMerchant) {
    state.loginMerchant = loginMerchant
  },

  handleUserLoginMerchants(
    state: RootState,
    userLoginMerchants: IUserLoginMerchants[]
  ) {
    state.userLoginMerchants = userLoginMerchants
  },

  handleUserInfo(state: RootState, userInfo: IStateUserInfo) {
    state.userInfo = userInfo
  },

  handleOptions(state: RootState, options: IWindowOptions) {
    state.options = options
  },

  handleMerchId(state: RootState, merchId: string) {
    state.merchId = merchId
  },

  handleHeaderTitle(state: RootState, headerTitle: string) {
    state.headerTitle = headerTitle
  },

  handleOrderList(state: RootState, orderList: IOrderDto[]) {
    state.orderList = orderList
  },

  handleKeyword(state: RootState, keyword: string) {
    state.keyword = keyword
  },

  handleShowLoading(state: RootState, showLoading: boolean) {
    state.showLoading = showLoading
  },

  handleShowSelectMerchantModal(
    state: RootState,
    showSelectMerchantModal: boolean
  ) {
    state.showSelectMerchantModal = showSelectMerchantModal
  },

  handleUnreadMessageCount(state: RootState, unreadMessageCount: number) {
    state.unreadMessageCount = unreadMessageCount
  },
  handleRefundOrderList(state: RootState, refundOrderList) {
    state.refundOrderList = refundOrderList
  },
  handleHistoryOrder(state: RootState, historyOrder) {
    state.historyOrder = historyOrder
  },
  handleUserCurrentHistoryDate(state: RootState, userCurrentHistoryDate) {
    state.userCurrentHistoryDate = userCurrentHistoryDate
  },
  handleNewMessageReceived(state: RootState, message: TrackableMessageDto) {
    state.newMessage = message
  },
  handleSignalRConnectionChanged(state: RootState, isConnected: boolean) {
    state.signalRConnected = isConnected
  },
  handleSignalRInitializingStatus(state: RootState, isInitializing: boolean) {
    state.initializingSignalR = isInitializing
  },
  handleClearIntervals() {
    clearInterval(window.wsConnectionTimer)
    clearInterval(window.pollingTimer)
    clearInterval(window.orderLoopPalySoundTimer)
  },
  handleRefreshPage(state: RootState, param) {
    state.options.token = param.token
    state.options.eventType = "Init"
    state.options.id = Math.random()
      .toString(36)
      .substring(2)
    state.options.oauthType = param.oauthType
    state.merchId = param.merchId
    state.openInBrowser = param.isopenInBrowser
    state.loginMerchant = Object.assign(
      state.loginMerchant,
      JSON.parse(param.loginMerchant)
    )
  },
  handleLoginMerchantInfo(state: RootState, loginMerchant: string) {
    state.loginMerchant = Object.assign(
      state.loginMerchant,
      JSON.parse(loginMerchant)
    )
  },
  handleAutoReadyOrders(state: RootState, autoReadyOrders: boolean) {
    state.autoReadyOrders = autoReadyOrders
  },
  handleReceiveMessage(state: RootState, receiveMessage: boolean) {
    state.receiveMessage = receiveMessage
  },
  handleClearOrderList(state: RootState) {
    state.orderList = []
  },
  handleCurrentOrderTab(state: RootState, orderTab: string) {
    state.currentOrderTab = orderTab
  },
  handleCurrentOrderPage(state: RootState, currentOrderPage: number) {
    state.currentOrderPage = currentOrderPage
  },
  handleIsInPreOrderTab(state: RootState, isInPreOrderTab: boolean) {
    state.inPreOrderTab = isInPreOrderTab
  },
  handlePreOrderDate(state: RootState, preOrderDate: string) {
    state.preOrderDate = preOrderDate
  },
  handleCurrentMessagePage(state: RootState, currentMessagePage: number) {
    state.currentMessagePage = currentMessagePage
  },
  handleupdateOrderListInSignalR(
    state: RootState,
    updateOrderListInSignalR: number
  ) {
    state.updateOrderListInSignalR = updateOrderListInSignalR
  },
  handleupdateOrderListInSignalRMessageCount(
    state: RootState,
    updateOrderListInSignalRMessageCount: number
  ) {
    state.updateOrderListInSignalRMessageCount = updateOrderListInSignalRMessageCount
  },
  handlePreOrderCountForDate(
    state: RootState,
    preOrderCountForDate: IPreOrderCount[]
  ) {
    state.preOrderCountForDate = preOrderCountForDate
  },
  handleRequestTimeStamp(state: RootState, timeStamp: number) {
    state.requestTimeStamp = timeStamp
  },
  handleExactSearch(state: RootState, exactSearch: boolean) {
    state.exactSearch = exactSearch
  },
  handleAcceptPreOrder(state: RootState, acceptPreOrder: boolean) {
    state.acceptPreOrder = acceptPreOrder
  },
  handleOrderCacheMinutes(state: RootState, orderCacheMinutes: number) {
    state.orderCacheMinutes = orderCacheMinutes
  },
  handleImRequestTimeStamp(state: RootState, ImRequestTimeStamp: number) {
    state.ImRequestTimeStamp = ImRequestTimeStamp
  },
  handleIsAsapOnly(state: RootState, isAsapOnly: boolean) {
    state.isAsapOnly = isAsapOnly
  },
  handleMerchDecideConfirmedTime(
    state: RootState,
    merchDecideConfirmedTime: boolean
  ) {
    state.merchDecideConfirmedTime = merchDecideConfirmedTime
  },
  handleIsPrintEnable(state: RootState, isPrintEnable: boolean) {
    state.isPrintEnable = isPrintEnable
  },
}

export default mutations
